import type {
  CompleteEventRegistrationRequest,
  CompleteEventRegistrationAttendee,
} from "@/modules/eventRegistration/features/EventRegistration/api/completeEventRegistration/types";

export interface RegistrationAttendeeInput {
  firstName: string;
  lastName: string;
  email?: string;
  isSelected: boolean;
  specialRequests?: string;
}

export interface BuildPayloadInput {
  eventSessionUuid: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string | null;
  groupNotes?: string | null;
  attendees: RegistrationAttendeeInput[];
  dataDescriptor: string;
  dataValue: string;
  amount: number;
  invoiceNumber: string;
  cardExpiration?: string | null;
  voucherQuantity?: number | null;
  discountCode?: string | null;
  /** sum of code + admin discount applied to the total — backend echoes this back */
  discountAmount?: number | null;
  adminDiscountType?: "percentage" | "fixed_amount" | null;
  adminDiscountValue?: number | null;
  adminDiscountReason?: string | null;
}

/**
 * Build the wire payload for completeEventRegistration. Centralizes the
 * "string -> undefined" coercions and the attendee-shape filtering so the
 * checkout component doesn't carry that inline.
 */
export function buildCompleteRegistrationPayload(
  input: BuildPayloadInput,
): CompleteEventRegistrationRequest {
  const selectedAttendees: CompleteEventRegistrationAttendee[] = input.attendees
    .filter((a) => a.isSelected)
    .map((a) => ({
      firstName: a.firstName,
      lastName: a.lastName,
      email: a.email,
      isSelected: a.isSelected,
      specialRequests: a.specialRequests,
    }));

  return {
    eventSessionUuid: input.eventSessionUuid,
    contactName: input.contactName,
    contactEmail: input.contactEmail,
    contactPhone: input.contactPhone || undefined,
    groupNotes: input.groupNotes || undefined,
    attendees: selectedAttendees,
    dataDescriptor: input.dataDescriptor,
    dataValue: input.dataValue,
    amount: input.amount,
    invoiceNumber: input.invoiceNumber,
    cardExpiration: input.cardExpiration || undefined,
    voucherQuantity: input.voucherQuantity || undefined,
    discountCode: input.discountCode || undefined,
    discountAmount: input.discountAmount || undefined,
    adminDiscountType: input.adminDiscountType || undefined,
    adminDiscountValue: input.adminDiscountValue || undefined,
    adminDiscountReason: input.adminDiscountReason || undefined,
  };
}
